export const QuestionAnswerHelper = {
    useDefaultValue<questionAnswer>() {
        if (!!!this.answer && !!this.questionDefault && this.questionDefault.length > 0) {
            this.answer = this.questionDefault[0].code;
        }
    }
}